const state = {
    loginForm: null,
    currentMenu: null
};

const mutations = {
    SET_LOGIN_FORM(state, loginForm) {
        state.loginForm = loginForm;
    },
    SET_CURRENT_MENU(state, menu) {
        state.currentMenu = menu;
    }
};

const actions = {
    setLoginForm({commit}, loginForm) {
        commit('SET_LOGIN_FORM', loginForm);
    },
    setCurrentMenu({commit}, menu) {
        commit('SET_CURRENT_MENU', menu);
    }
};

const getters = {
    loginForm: state => state.loginForm,
    currentMenu: state => state.currentMenu
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};